import React from "react";
import classNames from "classnames";

import Icon from "../Icon/Icon";
import styles from "./ZoomControl.module.scss";

interface Props {
  minZoomReached: boolean;
  maxZoomReached: boolean;
  className?: string;
  onZoomInClick?: () => void;
  onZoomOutClick?: () => void;
  theme?: "light" | "dark";
  dataQA: string;
}

const ZoomControl: React.FC<Props> = ({
  minZoomReached,
  maxZoomReached,
  className,
  onZoomInClick,
  onZoomOutClick,
  theme = "light",
  dataQA,
}) => {
  return (
    <div
      data-qa={dataQA}
      className={classNames(styles.container, className, styles[theme])}
    >
      <div
        className={classNames(styles.button, {
          [styles.disabled]: maxZoomReached,
        })}
        onClick={onZoomInClick}
        data-qa="zoom-in"
      >
        <Icon dataQA="plus" type="PlusIcon" />
      </div>
      <div
        className={classNames(styles.button, {
          [styles.disabled]: minZoomReached,
        })}
        onClick={onZoomOutClick}
        data-qa="zoom-out"
      >
        <Icon dataQA="minus" type="MinusIcon" />
      </div>
    </div>
  );
};

export default ZoomControl;
